import NavLinkPropsWithElement from '../../global/types/NavLinkPropsWithElement'
import Schedule from '../../schedule/components/main/ScheduleMain'
import WorkOrders from '../../work-orders/components/main/WorkOrdersMain'
import RescheduleQueue from '../../queues/components/main/QueuesMain'
import Cases from '../../cases/components/main/CasesMain'
import Technicians from '../../technicians/components/main/TechniciansMain'
import PromoCodes from '../../promo-codes/components/main/PromoCodesMain'
import Holidays from '../../holidays/components/main/HolidaysMain'
import Locations from '../../locations/components/main/LocationsMain'
import Reports from '../../reports/components/main/ReportsMain'
import { RequireAuth } from '../components/auth/RequireAuth'
import UserManagement from '../../user-management/main/UserManagementMain'
import ServicesMain from '../../services/main/ServicesMain'
import VansMain from '../../vans/main/VansMain'
import BiReportUploadsMain from '../../bi-report-uploads/components/main/BiReportUploadsMain'
import DashboardsMain from '../../dashboards/main/DashboardsMain'
import SmallPartSuppliesMain from '../../small-part-supplies/components/main/SmallPartSuppliesMain'

const linksData: Array<NavLinkPropsWithElement> = [
  {
    to: '/',
    title: 'Schedule',
    element: (
      <RequireAuth>
        <Schedule />
      </RequireAuth>
    ),
  },
  {
    to: '/work-orders',
    title: 'Work Orders',
    element: (
      <RequireAuth>
        <WorkOrders />
      </RequireAuth>
    ),
  },
  {
    to: '/queues',
    title: 'Queues',
    element: (
      <RequireAuth>
        <RescheduleQueue />
      </RequireAuth>
    ),
  },
  {
    to: '/cases',
    title: 'Cases',
    element: (
      <RequireAuth>
        <Cases />
      </RequireAuth>
    ),
  },
  {
    to: '/technicians',
    title: 'Technicians',
    element: (
      <RequireAuth>
        <Technicians />
      </RequireAuth>
    ),
  },
  {
    to: '/promo-codes',
    title: 'Promo Codes',
    element: (
      <RequireAuth>
        <PromoCodes />
      </RequireAuth>
    ),
  },
  {
    to: '/holidays',
    title: 'Holidays',
    element: (
      <RequireAuth>
        <Holidays />
      </RequireAuth>
    ),
  },
  {
  	to: '/vans',
  	title: 'Vans',
  	element: (
  		<RequireAuth>
        <VansMain/>
  		</RequireAuth>
  	),
  },
  {
  	to: '/small-part-supplies',
  	title: 'Small Part Inventory',
  	element: (
  		<RequireAuth>
        <SmallPartSuppliesMain/>
  		</RequireAuth>
  	),
  },
  {
    to: '/locations',
    title: 'Locations',
    element: (
      <RequireAuth>
        <Locations />
      </RequireAuth>
    ),
  },
  {
    to: '/services',
    title: 'Services',
    element: (
      <RequireAuth>
        <ServicesMain />
      </RequireAuth>
    ),
  },
  {
    to: '/reports',
    title: 'CS Reports',
    element: (
      <RequireAuth>
        <Reports />
      </RequireAuth>
    ),
  },
  {
    to: '/dashboards',
    title: 'Dashboards',
    element: (
      <RequireAuth>
        <DashboardsMain />
      </RequireAuth>
    ),
  },
  {
    to: '/bi-report-uploads',
    title: 'BI Report Uploads',
    element: (
      <RequireAuth>
        <BiReportUploadsMain />
      </RequireAuth>
    ),
  },
  {
    to: '/user-management',
    title: 'User Management',
    element: (
      <RequireAuth>
        <UserManagement />
      </RequireAuth>
    ),
  },
]

export default linksData
